import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav } from "react-bootstrap";
import user from "../../../images/user.jpg";

///Import
import PendingBlog from "./Guest/PendingBlog";
import BookedBlog from "./Guest/BookedBlog";
import CustomerFormModal from "./Modal/CustomerModal";
import ConfirmationModal from "./Modal/ConfirmationModal";

const DropdownBlog = ({ editFnc, deleteFnc }) => {
  return (
    <>
      <Dropdown className="dropdown">
        <Dropdown.Toggle
          as="div"
          className="btn-link i-false"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu">
          <Dropdown.Item onClick={() => editFnc?.()} className="dropdown-item">
            Edit
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => deleteFnc?.()}
            className="dropdown-item"
          >
            Delete
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

const CustomerList = () => {
  const [selectBtn, setSelectBtn] = useState("Newest");
  const [searchInput, setSearchInput] = useState("");
  const [customers, setCustomers] = useState(CustomersList || []);
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showConfirmation, setConfirmation] = useState(false);

  const filteredCustomers = (list) => {
    return list
      .filter((customer) =>
        [customer.name, customer.emailId, customer.mobileNo].some((field) =>
          field.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
      .sort((a, b) =>
        selectBtn === "Newest"
          ? b.lastBookingDate - a.lastBookingDate
          : a.lastBookingDate - b.lastBookingDate
      );
  };

  const deleteCustomer = (customer) => {
    setConfirmation(true);
    setSelectedCustomer(customer);
  };

  const handleDeleteCustomer = () => {
    setCustomers((curr) =>
      curr.filter((cust) => cust.id !== selectedCustomer.id)
    );
    setConfirmation(false);
    setSelectedCustomer(null);
  };

  const handleAddCustomer = () => {
    setSelectedCustomer(null); // Clear selected customer for a new form
    setShowModal(true);
  };

  const handleEditCustomer = (customer) => {
    setSelectedCustomer(customer); // Load customer data into the form
    setShowModal(true);
  };

  const handleFormSubmit = (formData) => {
    if (selectedCustomer) {
      // Update logic here
      setCustomers((curr) => {
        const updatedCustomers = curr.map((customer) => {
          if (customer.id === selectedCustomer.id) {
            customer = formData;
          }

          return customer;
        });
        return updatedCustomers;
      });
      console.log("Updated Customer:", formData);
    } else {
      // Add logic here
      setCustomers((curr) => ({ ...curr, formData }));
      console.log("New Customer:", formData);
    }
  };

  const [data, setData] = useState(
    document.querySelectorAll("#example2_wrapper tbody tr")
  );
  const sort = 8;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#example2_wrapper tbody tr"));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  const [state, setState] = useState({
    start: moment().subtract(29, "days"),
    end: moment(),
  });
  const { start, end } = state;
  const handleCallback = (start, end) => {
    setState({ start, end });
  };
  const label =
    start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY");

  // handle status change
  const onStatusChange = (id, status) => {
    // call post api to change status
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="All">
                  All
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="Active">
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="Inactive">
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="flex flex-row align-items-center mb-2 gap-x-2 ">
            <input
              type="text"
              placeholder="Search by name, email, or mobile"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="search-input form-control"
            />
            <select
              value={selectBtn}
              onChange={(e) => setSelectBtn(e.target.value)}
              className="form-control"
            >
              <option value="Newest">Newest</option>
              <option value="Oldest">Oldest</option>
            </select>

            <button
              onClick={handleAddCustomer}
              className="gradient_one text-nowrap text-white px-2 w-full self-stretch rounded-lg"
            >
              Add Customer
            </button>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="table-responsive">
                      <div
                        id="example2_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="example2"
                          className="table card-table display mb-4 shadow-hover default-table dataTablesCard dataTable no-footer"
                        >
                          <thead>
                            <tr role="row">
                              <th className="sorting_asc">Customer Name</th>
                              <th className="sorting">Email Id</th>
                              <th className="sorting">Mobile Number</th>
                              <th className="sorting">Total Bookings</th>
                              <th className="sorting">Last Booking Date</th>
                              <th className="sorting">Status</th>
                              <th className="sorting">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredCustomers(customers).map((customer) => (
                              <tr key={customer.id} role="row" className="odd">
                                <td>
                                  <div className="concierge-bx flex flex-col lg:flex-row align-items-center">
                                    <img
                                      className="me-3 w-full lg:w-[300px] rounded"
                                      src={customer.profilePic || user}
                                      alt=""
                                    />
                                    <div>
                                      <h5 className="fs-16 mb-0 text-nowrap">
                                        <Link
                                          to={`/customer-details/${customer.id}`}
                                          className="text-black"
                                        >
                                          {customer.name}
                                        </Link>
                                      </h5>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-nowrap">
                                  <span>{customer.emailId}</span>
                                </td>
                                <td>
                                  <div>
                                    <h5 className="text-nowrap">
                                      {customer.mobileNo}
                                    </h5>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <h5 className="text-nowrap">
                                      {customer.totalBookings}
                                    </h5>
                                  </div>
                                </td>
                                <td className="request">
                                  {new Date(
                                    customer.lastBookingDate
                                  ).toLocaleDateString()}
                                </td>
                                <td>
                                  <p
                                    className={`${
                                      customer.status === "Active"
                                        ? "bg-green-600"
                                        : "bg-red-600"
                                    } text-center font-semibold px-3 py-2 rounded-md text-white`}
                                  >
                                    {customer.status}
                                  </p>
                                </td>
                                <td>
                                  <DropdownBlog
                                    editFnc={() => handleEditCustomer(customer)}
                                    deleteFnc={() => deleteCustomer(customer)}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                          <div className="dataTables_info">
                            Showing {activePag.current * sort + 1} to{" "}
                            {data.length > (activePag.current + 1) * sort
                              ? (activePag.current + 1) * sort
                              : data.length}{" "}
                            of {data.length} entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers mb-0"
                            id="example2_paginate"
                          >
                            <Link
                              className="paginate_button previous disabled"
                              to="/customer-list"
                              onClick={() =>
                                activePag.current > 0 &&
                                onClick(activePag.current - 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-left"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <span>
                              {paggination.map((number, i) => (
                                <Link
                                  key={i}
                                  to="/customer-list"
                                  className={`paginate_button  ${
                                    activePag.current === i ? "current" : ""
                                  } `}
                                  onClick={() => onClick(i)}
                                >
                                  {number}
                                </Link>
                              ))}
                            </span>

                            <Link
                              className="paginate_button next"
                              to="/customer-list"
                              onClick={() =>
                                activePag.current + 1 < paggination.length &&
                                onClick(activePag.current + 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-right"
                                aria-hidden="true"
                              ></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Active">
                    <PendingBlog
                      customersData={CustomersList.filter(
                        (customer) => customer.status === "Active"
                      )}
                      onStatusChange={onStatusChange}
                      filteredCustomers={filteredCustomers}
                      searchInput={searchInput}
                      selectBtn={selectBtn}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <BookedBlog
                      customersData={CustomersList.filter(
                        (customer) => customer.status === "Inactive"
                      )}
                      onStatusChange={onStatusChange}
                      filteredCustomers={filteredCustomers}
                      searchInput={searchInput}
                      selectBtn={selectBtn}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
      {showModal && (
        <CustomerFormModal
          show={showModal}
          onClose={() => setShowModal(false)}
          customerData={selectedCustomer}
          onSubmit={handleFormSubmit}
        />
      )}
      {showConfirmation && (
        <ConfirmationModal
          showModal={showConfirmation}
          closeModal={() => setConfirmation(false)}
          title="Customer will be deleted."
          onConfirm={() => handleDeleteCustomer()}
        />
      )}
    </>
  );
};

const CustomersList = [
  {
    id: "ksjldf2390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 16"),
    status: "Active",
  },
  {
    id: "ksjsvf2390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 16"),
    status: "Active",
  },
  {
    id: "k232f2390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 16"),
    status: "Inactive",
  },
  {
    id: "ksjl4232390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 321 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 11"),
    status: "Active",
  },
  {
    id: "ksjlvs22390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 18"),
    status: "Active",
  },
  {
    id: "ksjl223390209",
    profilePic: "",
    name: "John Martin",
    emailId: "doe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 12"),
    status: "Active",
  },
  {
    id: "ksv2df2390209",
    profilePic: "",
    name: "John Doe",
    emailId: "john@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 11"),
    status: "Active",
  },
  {
    id: "k2221f2390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 10"),
    status: "Active",
  },
  {
    id: "ks2235f2390209",
    profilePic: "",
    name: "John Doe",
    emailId: "johndoe@email.com",
    mobileNo: "+91 123 456 7890",
    totalBookings: 12,
    lastBookingDate: new Date("2024, 12, 16"),
    status: "Active",
  },
];

export { DropdownBlog };
export default CustomerList;
